module.exports = __webpack_public_path__ + "static/media/4-DIY-Guide-prevent-sexual-assault.696f9489.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/4-DIY-Guide-prevent-sexual-assault.jpg
// module id = 140
// module chunks = 0